import { Link } from "react-router";

import { EndLinkButton } from "./GraphLinkEditor";
import { RecordRow } from "./record/RecordCard";
import { linkTypeLabel } from "./linkLabels";
import { MUTED, RECORD_LINK } from "./record/styles";

/** A current graph link as the deal and company routes list it (W8 D6). */
export interface GraphLink {
  id: string;
  link_type_id: string;
  direction: "outgoing" | "incoming";
  other_type: "contact" | "company" | "deal" | "property";
  other_id: string;
  other_name: string | null;
  pipeline_name: string | null;
  stage_label: string | null;
}

const PLURAL = { contact: "contacts", company: "companies", deal: "deals" };

/** The linked records, each with where a deal is (pipeline · stage). */
export function GraphLinkList({
  links,
  showType = false,
  canEnd = false,
}: {
  links: GraphLink[];
  /** Prefix each with its link type, for lists that mix types. */
  showType?: boolean;
  /** Offer End on each link (the user's role may change links, W9 F5). */
  canEnd?: boolean;
}) {
  return (
    <ul>
      {links.map((link) => (
        <RecordRow
          key={link.id}
          primary={
            <>
              {showType ? (
                <span className={MUTED}>{linkTypeLabel(link)}: </span>
              ) : null}
              {link.other_type === "property" ? (
                // No property page yet (W14 P3): the address, as text.
                <span>{link.other_name}</span>
              ) : (
                <Link
                  className={RECORD_LINK}
                  to={`/${PLURAL[link.other_type]}/${link.other_id}/show`}
                >
                  {link.other_name}
                </Link>
              )}
            </>
          }
          secondary={
            link.pipeline_name
              ? `— ${link.pipeline_name} · ${link.stage_label}`
              : null
          }
          trailing={
            canEnd ? (
              <EndLinkButton linkId={link.id} label={link.other_name ?? ""} />
            ) : null
          }
        />
      ))}
    </ul>
  );
}
